// Copyright (c) StrangeBee 2024

import { useCallback, useState } from 'react';

export enum SortDirections {
    NONE,
    ASC = 1,
    DESC = -1,
}

export interface UseSortReturn {
    sortList: string[];
    addSort: (field: string, sortOrder: SortDirections) => string[];
    getFieldSort: (field: string) => SortDirections;
}

const useSort = (initialValue: string[]): UseSortReturn => {
    const [sortList, setSortList] = useState<string[]>(initialValue);

    const addSort = (field: string, sortOrder: SortDirections): string[] => {
        const newSortList =
            sortOrder !== SortDirections.NONE ? [`${sortOrder === SortDirections.ASC ? '+' : '-'}${field}`] : [];
        setSortList(newSortList);
        return newSortList;
    };

    const getFieldSort = useCallback(
        (field: string): SortDirections => {
            const sign = sortList.find((sort) => sort.substring(1) === field)?.charAt(0) || '';

            if (sign) {
                return sign === '+' ? SortDirections.ASC : SortDirections.DESC;
            }

            return SortDirections.NONE;
        },
        [sortList],
    );

    return { sortList, addSort, getFieldSort };
};

export default useSort;
